import { useMoveReportSectionFieldToAnotherSectionMutation } from "@api/graphql/types-and-hooks";
import { notifyError } from "@components/notifications/notifications";
import { useReport } from "@providers/ReportProvider";

export const useMoveFieldToSection = () => {
  const { reportQuery } = useReport();
  const { mutate } = useMoveReportSectionFieldToAnotherSectionMutation({
    onSuccess: async (data) => {
      if (data.moveReportSectionFieldToAnotherSection?.status) {
        await reportQuery.refetch();
      } else if (data.moveReportSectionFieldToAnotherSection?.status === false) {
        notifyError(data.moveReportSectionFieldToAnotherSection?.message ?? "Error moving field to section");
      }
    },
    onError: (error) => {
      console.error("Error while moving field to section:", error);
      notifyError("Error Moving Field");
    },
  });

  return mutate;
};
